import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { DownloadIcon, MailIcon, XIcon } from 'lucide-react';

// Email guardians and Export only. No bulk status: status changes stay on the booking page.
export function BulkActionBar({ count, onEmail, onExport, onClear }) {
  const btn =
    'tw-inline-flex tw-h-8 tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-lg tw-px-2.5 tw-text-sm tw-font-medium tw-text-neutral-900 tw-transition-colors tw-duration-150 hover:tw-bg-sand-50';
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
          className="tw-fixed tw-inset-x-0 tw-bottom-6 tw-z-40 tw-flex tw-justify-center tw-px-4">
          <div role="toolbar" aria-label="Bulk actions" className="tw-flex tw-flex-wrap tw-items-center tw-gap-1 tw-rounded-xl tw-border tw-border-neutral-200 tw-bg-white tw-p-1.5 tw-shadow-xl">
            <span className="tw-flex tw-h-8 tw-items-center tw-gap-2 tw-rounded-lg tw-bg-brand-50 tw-px-3 tw-text-sm tw-font-medium tw-text-brand-600">
              <span className="tw-tabular-nums">{count}</span> selected
            </span>
            <span className="tw-mx-1 tw-h-5 tw-w-px tw-bg-neutral-200" aria-hidden />
            <button type="button" onClick={onEmail} className={btn}>
              <MailIcon className="tw-h-4 tw-w-4 tw-text-neutral-500" aria-hidden />
              Email guardians
            </button>
            <button type="button" onClick={onExport} className={btn}>
              <DownloadIcon className="tw-h-4 tw-w-4 tw-text-neutral-500" aria-hidden />
              Export
            </button>
            <span className="tw-mx-1 tw-h-5 tw-w-px tw-bg-neutral-200" aria-hidden />
            <button
              type="button"
              onClick={onClear}
              aria-label="Clear selection"
              className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-text-neutral-500 tw-transition-colors hover:tw-bg-sand-50 hover:tw-text-neutral-900">
              <XIcon className="tw-h-4 tw-w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
